const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

export const BROCHURES = {
  product: {
    id: 'product',
    title: 'Product Brochure',
    subtitle: 'DocChoice hospital platform',
    fileName: 'DocChoice-Website-Brochure.pdf',
    href: `${publicBase}/brochures/DocChoice-Website-Brochure.pdf`,
  },
  hr: {
    id: 'hr',
    title: 'HR Brochure',
    subtitle: 'HR & Payroll management',
    fileName: 'DocChoice-HR-Brochure.pdf',
    href: `${publicBase}/brochures/DocChoice-HR-Brochure.pdf`,
  },
};

export const BROCHURE_LIST = [BROCHURES.product, BROCHURES.hr];
